import React from 'react'
import { Box, Typography } from '@mui/material'
import { useMemo, useState, useCallback, useEffect } from 'react'

import { AssetInnerTable, AccountRow, CallToActionRow } from 'atoms/AssetsTable'
import { useModal } from 'components/modals'
import { useFinances } from 'hooks/useFinances'

import TSPLoanAssets from 'components/TSPLoanAssets'

const dollarFormat = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
})

function TSPLoan({ demoMode }) {
  return (
    <Box sx={{ textAlign: 'left' }} pb={3}>
      <Box mb={1}>
        <Typography variant="h4" color={'#262627'}>
          Total Loan Details
        </Typography>
      </Box>
      <Typography variant="body1" color={'#495057'}>
        Please edit or add any TSP loans you might have
      </Typography>

      <TSPLoanAssets />
    </Box>
  )
}

export default TSPLoan
